import React from "react";
import {
  makeStyles,
  Box,
  Container,
  Grid,
  Typography,
  Button,
} from "@material-ui/core";
import { NavLink as RouterLink } from "react-router-dom";
import { AnimationOnScroll } from "react-animation-on-scroll";
const useStyles = makeStyles((theme) => ({
  cryptoBox: {
    position: "relative",
    zIndex: "9",
    padding: "50px 0",
    "& img": {
      width: "auto",
      maxWidth: "100%",
    },
    "& h2": {
      lineHeight: "60px",
    },
    "& svg": {
      fontSize: "25px",
      color: "rgba(255, 255, 255, 0.25)",
    },
    "& .logoBox": {
      padding: "30px 0",
      "& img": {
        width: "auto",
        maxWidth: "180px",
        [theme.breakpoints.down("xs")]: {
          maxWidth: "139px",
        },
      },
    },
  },
}));

function Crypto() {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.cryptoBox}>
        <Container maxWidth="lg">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} lg={5} sm={5} md={5}>
              <AnimationOnScroll animateIn="animate__fadeInLeft">
                <Typography variant="h3" color="primary">
                  {/* The Secure app to store crypto yourself */}
                  Next-Generation Cryptocurrency Trading Platform
                </Typography>
              </AnimationOnScroll>

              {/* <Box className="displayStart" mt={2}>
                <RiCheckboxCircleFill />
                &nbsp;&nbsp;
                <Typography variant="body1" color="primary">
                  All your digital assets in one place
                </Typography>
              </Box>

              <Box className="displayStart" mt={1}>
                <RiCheckboxCircleFill />
                &nbsp;&nbsp;
                <Typography variant="body1" color="primary">
                  Use Decentralized Apps
                </Typography>
              </Box>
              <Box className="displayStart" mt={1}>
                <RiCheckboxCircleFill />
                &nbsp;&nbsp;
                <Typography variant="body1" color="primary">
                  Pay friends, not addresses
                </Typography>
              </Box> */}
              <Box mt={2}>
                <Typography variant="body2" className="grayText">
                  Fierex is the next-generation cryptocurrency trading platform,
                  Fierex, for sophisticated crypto transactions that go beyond
                  buying and selling. With secure payment solutions and
                  increased economic freedom, Fierex is the platform that offers
                  more than just trading. Start trading confidently today!
                </Typography>
              </Box>
              <Box mt={3}>
                <Button
                  variant="contained"
                  color="primary"
                  target="_blank"
                  // component={RouterLink}
                  href="https://bitedge.app/"
                  // href="https://fieroscan.com/"
                  // to="/explore"
                >
                  visit now
                </Button>
              </Box>
              {/* <Box mt={1}>
                <Typography variant="body2">
                Mobile Apps available on:</Typography>
              </Box>
              <AnimationOnScroll animateIn="animate__fadeInUp">
                <Box className="displayStart logoBox">
                  <img src="images/google.png" alt="images" style={{cursor:"pointer"}} /> &nbsp;&nbsp;
                  <img src="images/apple.png" alt="images" style={{cursor:"pointer"}} />
                </Box>
              </AnimationOnScroll> */}
            </Grid>
            <Grid item xs={12} lg={7} sm={7} md={7}>
              <AnimationOnScroll animateIn="animate__fadeInRight">
                <img src="images/crypto.png" alt="image" />
              </AnimationOnScroll>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default Crypto;
